// @ts-nocheck
import { useParams } from "react-router-dom"
import { PostDetailView } from "@/components/post/PostDetailView"
import { useAuth } from "@/components/layout/AuthProvider"

export default function PostDetailPage() {
  const { id } = useParams<{ id: string }>()
  const { supabaseUser } = useAuth()

  if (!id) return <div className="text-center py-16 text-text-muted">Post not found</div>

  return (
    <div className="container-narrow py-4">
      <PostDetailView postId={id} userId={supabaseUser?.id || null} />
    </div>
  )
}